export default '/home/qtomdynx/public_html/modules/custom/vue_apps/assets/source'